let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bUZ7U")).then(() => parcelRequire('77Eyd'));